import sortableTable from "./sortable-table";

export default {
    sortableTable
};
